import { z } from "zod";

// Helper function to type-safe and labelled Zod-based enums from a key-value pair.
// Returns a record of values (labels) for displaying (e.g. in dropdowns, see
// establishment-date.tsx) and a Zod enum for type safety.
export const createLabeledEnum = <
  T extends Record<string, string>,
  TKeys extends keyof T & string = keyof T & string,
>(
  values: T & { [K in TKeys]: string },
) => {
  const keys = Object.keys(values) as TKeys[];
  const map = new Map<string, string>(keys.map((key) => [key, values[key]]));
  return {
    values,
    map,
    enum: z.enum(keys as [TKeys, ...TKeys[]], {
      message: "Dette felt er påkrævet",
    }),
  };
};

export type InferLabeledEnum<T> =
  T extends ReturnType<typeof createLabeledEnum> ? z.infer<T["enum"]> : never;
